import angular from "angular"

const MODULE_NAME = "fichaAlumnoModule"

angular.module(MODULE_NAME, ["ngRoute"])

export default MODULE_NAME
